import { useFormikContext } from 'formik';
import { Button } from 'primereact/button';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

const messages = defineMessages({
  next: { id: 'actions.next', defaultMessage: 'Next' },
  previous: { id: 'actions.previous', defaultMessage: 'Previous' },
  decline: { id: 'actions.decline', defaultMessage: 'Decline' },
});

const EssentialAccountOrganizationDetailStepButtons = ({ userExists, token }) => {
  const history = useHistory();
  const { formatMessage } = useIntl();
  const { isValid, isSubmitting } = useFormikContext();

  const isNextDisabled = !isValid || isSubmitting;

  return (
    <div>
      {userExists ? (
        <Button
          type="button"
          label={formatMessage(messages.decline)}
          onClick={() => history.push(`/account-invitation-decline?token=${token}`)}
        />
      ) : (
        <Button type="button" label={formatMessage(messages.previous)} onClick={() => history.goBack()} />
      )}
      <Button type="submit" label={formatMessage(messages.next)} disabled={isNextDisabled} />
    </div>
  );
};

export default EssentialAccountOrganizationDetailStepButtons;
